function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("image", {
  width: 54,
  height: 54,
  xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2CAYAAACMRWrdAAACjElEQVRoge2aO27bQBCGf25eQAADTJtKAQwlpW9gGWCRVFFuEJ0gLtNFPkHkE8Q3oFSlERDrBFaZEAbEKq3UOi4YDDOrkFzSlMzX7sIfMIKhB81Ps4/R7jqoFxfAAMARgGMAPY48Qo4FgCWASwCbnPd1Bsl8BOADiCqGz9dyuxSiTHwFsK5BKBtrvnZRthuBvs1xQ0J5guM2Mkj9Z5VzA03Hiv93I4w7EMrGuE4xt6aBoa7w62iadIErjaRkXFWR01WqspxOza8ofOWuS9BhoNg1dh5QBgZJySidCtyO5qmqscr2t0cZsc8Ahoqu/pDUDRfSCr2WyqSmYp2sLUXC7lPXVXVFXHZI4RqeLRlrmZzH9DDBy+E1/picLYl7iKfDU/y+iMXe4uC98hZzIZcL5ydey2ZoEy9Ek79zOmQgeOHFNo4ErybZxrFoe8GkJXpWi1nJg5hpPIiZhuAdD9sIrRZbKE+bz0LwppttLEXRAojhXIo3+EXbo1OLpKbkFP+CPnj3fPbs8ImJy24KN9e3M3wH4s31KPDcvEVHA6HW98rpzzfxBE1/0DqB4VKI1zr+uaQqj3PdjiPsyYYdYrZiTn8eJl8wkHN2SIsxE0MrkZDvfUtKjNvnSPmY/oxk38oVYzmasM8Mkjrje05ReJYqCjzfgC2lqdOff1CezctYgpHmdeTyrm5TmDH8n7h/aLioSlIn2X6V5K6MycHkRLNaclomhbKMJYkCj3bnvygvtAsNFDudEtjrIGYUeLSB8a2DRdaQh3Rl9Cti7xOm3O9OW9ralWXSpKzpZbn30dko8Hos18SJUFmUp8qkfah8JpgzOOSdxKrzHg0MM56fKhXktR52Zsl7H3auKrMFwF9uLoWtVv3h5wAAAABJRU5ErkJggg=="
});

var SvgGermany = function SvgGermany(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGermany, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/germany.790fb119.svg";
export { ForwardRef as ReactComponent };